import React, { useState } from 'react'
import PropTypes from 'prop-types'
import posed from 'react-pose'
import moment from 'moment'
import Button from './Button'
import PosedMountWrapper from './posed/PosedMountWrapper'

const propTypes = {
  data: PropTypes.object,
}

const PosedWrapper = posed.div({
  start: { opacity: 0, y: '10px' },
  end: {
    opacity: 1,
    staggerChildren: 50,
    delayChildren: 500,
    y: '0px',
    transition: {
      duration: 800,
    },
  },
})

const PosedFooter = posed.div({
  start: { opacity: 0 },
  end: {
    opacity: 1,
    delay: 500,
    transition: {
      duration: 1000,
    },
  },
})

const Welcome = ({ onGetPinClick }) => (
  <>
    <PosedMountWrapper>
      <h2
        className="mb-4 text-2xl font-semibold leading-tight"
        data-cy="locker-welcome"
      >
        Welcome to Morrisons Click & Collect
      </h2>
    </PosedMountWrapper>
    <PosedMountWrapper>
      <p>
        Please click the button below to retrieve your 6 digit locker pin code.
      </p>
    </PosedMountWrapper>
    <PosedMountWrapper className="mt-12 mb-2" initialPose="start" pose="end">
      <Button
        variant="tertiary"
        onClick={() => {
          onGetPinClick()
        }}
      >
        <span className="flex items-center justify-center block w-full px-2 text-center">
          <span className="block px-2">Get my pin code</span>
        </span>
      </Button>
    </PosedMountWrapper>
  </>
)

const Details = ({ smsCode }) => (
  <>
    <PosedMountWrapper>
      <h2 className="mb-4 text-2xl font-semibold leading-tight">
        Your 6 digit pin code is below. You will need this to collect your
        shopping from the lockers
      </h2>
    </PosedMountWrapper>
    <PosedMountWrapper>
      <p>
        Please have your ID ready to show if your order contains any age
        restricted items.
      </p>
    </PosedMountWrapper>
    <PosedMountWrapper className="mt-12 mb-2" initialPose="start" pose="end">
      <div className="flex justify-between" data-cy="locker-pin">
        {[...smsCode].map(num => (
          <span
            className="px-4 py-5 text-2xl font-semibold rounded-lg bg-primary-lightest"
            key={num}
          >
            {num}
          </span>
        ))}
      </div>
    </PosedMountWrapper>
  </>
)

const CardLocker = props => {
  const [showPin, setShowPin] = useState(false)
  const { data } = props

  if (!data) return null

  const { planned_delivery_time, planned_expiry_time, sms_code } = data

  let formattedDate = '',
    startTimeLocal = '',
    endTimeLocal = ''

  if (planned_delivery_time && planned_expiry_time) {
    const pickUpDate = planned_delivery_time.split(' ')[0]
    formattedDate = moment(pickUpDate).format('Do MMMM')

    const startTime = moment.utc(planned_delivery_time)
    const endTime = moment.utc(planned_expiry_time)

    startTimeLocal = startTime.local().format('HH:mm')
    endTimeLocal = endTime.local().format('HH:mm')
  }

  return (
    <div>
      <PosedFooter
        initialPose="start"
        pose="end"
        className="fixed bottom-0 left-0 z-auto w-full shadow-lg bg-body-lightest lg:max-w-lg h-55vh will-change-transform"
      />
      <PosedWrapper
        initialPose="start"
        pose="end"
        className="relative flex flex-col p-6 mb-12 overflow-hidden bg-white rounded-lg shadow-md"
      >
        <div className="p-4 mb-4 -m-6 text-sm text-center border-t border-dashed bg-body-lightest border-body-border">
          <span className="font-semibold">Collection time</span>
          <div className="leading-none" data-cy="locker-time">
            {formattedDate} &nbsp;
            <span className="inline-block mt-1 text-lg font-semibold">
              <span>{startTimeLocal}</span>
              <span> &ndash; </span>
              <span>{endTimeLocal}</span>
            </span>
          </div>
        </div>
        {showPin ? (
          <Details smsCode={sms_code} />
        ) : (
          <Welcome
            onGetPinClick={() => {
              setShowPin(true)
            }}
          />
        )}
      </PosedWrapper>
    </div>
  )
}

CardLocker.propTypes = propTypes

export default CardLocker
